var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ssh",style:({height: _vm.layout.height})},[_c('widget_terminal',{ref:"ref_terminal",attrs:{"bottom":_vm.layout.bottom,"height":_vm.layout.height,"width":_vm.layout.width}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }